import { intersect, nullable, partial, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { ParentId } from '../../../file/ParentId';
import { Id as FolderId } from '../../../folder/Id';

export const Request = intersect(
	struct({
		name: iotsUtils.NotEmptyString,
	})
)(
	partial({
		parentFolderId: nullable(union(ParentId, FolderId)),
	})
);
